interface ApiResponse {
    Bgid?: number
    GroupName?: string,
    groupcode?: string,
    status?: number,
    Status?: boolean,
    maxlimit?: number,
    Notes?: string,
    IsPrefilled: boolean | number,
    IsMandatory: boolean | number,
    Isdaily: boolean | number,
    Commentreq: boolean | number,
    Permonth: boolean | number,
    Mode: boolean | number,
    AttachmentRequired: boolean | number,
    Nonreimbursable: boolean | number
}


export const mapExpenseData = (data: any) => {
    
    const purposeRoleData = data?.data?.Budgets?.map((item:any)=>(item?.Bgid)||[])
    // console.log('purposeRoleData',purposeRoleData);
    return {
        title: data?.data?.ExpenseName || "",
        sortOrder: data?.data?.SortOrder || "",
        policyKey: data?.data?.DefaultPolicykey || "",
        trips: data?.data?.Trips || "",

        metroClassA: data?.data?.Policykeya || "",
        metroClassB: data?.data?.Policykeyb || "",
        others: data?.data?.Policykeyc || "",

        expanseRemark: "",
        purposeRoles: purposeRoleData,
        checkedItems: [
            { label: "Mandatory", value: "IsMandatory", checked: data?.data?.IsMandatory === 1 },
            { label: "Is prefilled", value: "IsPrefilled", checked: data?.data?.IsPrefilled === 1 },
            { label: "Paid by company", value: "AttachmentRequired", checked: data?.data?.AttachmentRequired === 1 },
            { label: "Expense remark required", value: "Commentreq", checked: data?.data?.Commentreq === 1 },
            { label: "Once per month", value: "Permonth", checked: data?.data?.Permonth === 1 },
            { label: "Has options", value: "Mode", checked: data?.data?.Mode === 1 },
            { label: "Attachment Required", value: "AttachmentRequired", checked: data?.data?.AttachmentRequired === 1 },
            { label: "Is rate Applied", value: "Isdaily", checked: data?.data?.Isdaily === 1 },
            { label: "CheckCity", value: "checkCity", checked: data?.data?.Checkcity === 1 },
        ],
    }
}